import api from "../../api";
export const messageOf = (e) => {
  const data = e?.response?.data;
  for (const value of [data?.error, data?.message]) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  const fallback = {
    400: "Confira os dados e o arquivo enviado antes de tentar novamente.",
    401: "Sua sessão expirou. Entre novamente para continuar.",
    403: "Você não tem permissão para esta operação.",
    409: "Os dados foram atualizados. Confira a etapa e tente novamente.",
    413: "O arquivo excede o limite permitido para envio.",
    429: "Aguarde um momento antes de tentar novamente.",
    502: "O serviço está temporariamente indisponível. Tente novamente em instantes.",
    503: "O serviço está temporariamente indisponível. Tente novamente em instantes.",
    504: "O serviço demorou para responder. Consulte o resultado antes de reenviar.",
  }[e?.response?.status];
  if (fallback) return fallback;
  if (e?.isAxiosError && !e.response)
    return "Não foi possível conectar. Confira sua conexão e tente novamente.";
  return typeof e?.message === "string" &&
    !/^Request failed with status code \d+$/i.test(e.message)
    ? e.message
    : "Não foi possível concluir a operação.";
};
export const statusLabels = {
  PENDING: "Aguardando assinatura",
  PARTIAL: "Parcialmente assinado",
  COMPLETED: "Assinado",
  DECLINED: "Recusado",
  EXPIRED: "Expirado",
  CANCELED: "Cancelado",
};
export const createSignature = async (file, configuration) => {
  const body = new FormData();
  if (file) body.append("file", file);
  body.append("configuration", JSON.stringify(configuration));
  return (await api.post("/signatures", body)).data;
};
export const downloadSignature = async (id, kind = "final") => {
  const route =
    kind === "evidence"
      ? `/signatures/${id}/evidence`
      : `/signatures/${id}/download/${kind}`;
  const { data } = await api.get(route, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download =
    kind === "evidence"
      ? "evidencias.pdf"
      : kind === "final"
        ? "documento-assinado.pdf"
        : "original.pdf";
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
};
